import React, { useMemo, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function ScoreboardScreensCarousel({ screenshots = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentScreenshot = useMemo(() => {
    return screenshots[currentIndex] || null;
  }, [currentIndex, screenshots]);

  const handlePrevious = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? screenshots.length - 1 : prev - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % screenshots.length);
  };

  if (!currentScreenshot) return null;

  return (
    <section className="mt-6 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="border-b border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/[0.03]">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-blue-600 dark:text-blue-200">
          Aperçu application Android
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          Captures JudoScore Pro
        </h2>

        <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
          Visualise les principaux écrans de l'application Android.
        </p>
      </div>

      <div className="grid gap-0 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="flex flex-col justify-center p-5 sm:p-6">
          <h3 className="font-titre text-3xl font-bold text-slate-950 dark:text-white">
            {currentScreenshot.caption}
          </h3>

          <p className="mt-3 text-sm font-medium leading-7 text-slate-500 dark:text-white/50">
            Capture {currentIndex + 1} / {screenshots.length}
          </p>

          <div className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-1">
            <button
              type="button"
              onClick={handlePrevious}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-blue-200 hover:text-blue-700 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
            >
              <FaArrowLeft />
              Précédent
            </button>

            <button
              type="button"
              onClick={handleNext}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-blue-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-700"
            >
              Suivant
              <FaArrowRight />
            </button>
          </div>

          <div className="mt-5 flex gap-2">
            {screenshots.map((screenshot, index) => (
              <button
                key={screenshot.src}
                type="button"
                onClick={() => setCurrentIndex(index)}
                className={`h-2.5 flex-1 rounded-full transition ${
                  index === currentIndex
                    ? "bg-blue-600"
                    : "bg-slate-200 dark:bg-white/10"
                }`}
                aria-label={`Voir ${screenshot.caption}`}
              />
            ))}
          </div>
        </div>

        <div className="bg-slate-100 p-5 dark:bg-slate-950 sm:p-6">
          <div className="mx-auto flex max-h-[720px] max-w-md items-center justify-center overflow-hidden rounded-[2rem] bg-white shadow-2xl dark:bg-white/[0.03]">
            <img
              src={currentScreenshot.src}
              alt={currentScreenshot.alt}
              className="max-h-[720px] w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ScoreboardScreensCarousel;